import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
import './assets/fonts/stylesheet.css';
// import './App.css';

import { PlayerRegistration } from './pages/playerRegistration';
import { Video } from './pages/video';
import { Preparation } from './pages/preparation';
import { Game } from './pages/game';
import { RoundSwitch } from './pages/roundswitch';
import { Income } from './pages/income';
import { Scenario } from './pages/scenario';
import { Endscore } from './pages/endscore';
import { Refresh } from './pages/refresh';

import { Introduction } from './pages/introduction';

import { ErrorBoundry } from './components/errorCatchall';

import { Page } from './pages/page';
import { Leaderboard } from './pages/leaderboard';

class App extends Component {

  componentWillMount(){
  }

  render() {
    return (
      <div className="App">
        <link href="/game/untracked/overwriteStyles.css" rel="stylesheet" />
        <ErrorBoundry>
          <Router basename="game">
            <div>
              <Route exact path='/' component={PlayerRegistration} />
              <Route exact path='/intro' component={Introduction} />
              <Route exact path='/video' component={Video} />
              <Route exact path='/preparation' component={Preparation} />

              <Route exact path='/game' component={Game} />

              <Route exact path='/roundswitch' component={RoundSwitch} />
              <Route exact path='/income' component={Income} />
              <Route exact path='/scenario' component={Scenario} />

              <Route exact path='/endscore' component={Endscore} />

              <Route exact path='/pageStyle' component={Page} />
              <Route exact path='/refresh' component={Refresh} />

              <Route exact path='/leaderboard' component={Leaderboard} />
            </div>
          </Router>
        </ErrorBoundry>
      </div>
    );
  }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js